import Navbar from "./components/Navbar";
import Home from "./pages/home";
import Menu from "./pages/menu";
import Location from "./pages/location";
import Contact from "./pages/contact";

function App() {
  return (
    <>
      <Navbar />
      <Home />
      <Menu />
      <Location />
      <Contact />
    </>
  );
}

export default App;
